export default __webpack_public_path__ + "static/media/gccc_logo.6ba20049.png";